module.exports = __webpack_public_path__ + "img/slide16_vn.f730b8af.jpg";